import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export type GetAccountImageServerResponse = {
    content: AccountImageResponseItem[]
    total_count: number
    page_size: number
}

export type AccountImageResponseItem = {
    id: string
    deleted: boolean
    location_id?: Maybe<string>
    terminal_id?: Maybe<string>
    path?: Maybe<string>
    type: string
    version: number
}

export const getAccountImageApi = (headers: Record<string, any>): Rx.Observable<GetAccountImageServerResponse> =>
    Rx.from(
        request({
            method: "GET",
            path: "/data/account-image",
            headers: headers,
        })
    ).pipe(retry(3))
